import { DatePicker, Input, Select, Space } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useGetAllDepartmentsQuery } from "../../../../../../app/features/employee/emp-dashboard/emp-dashboard.api";
import { ChevronDownIcon, Calendar03Icon, SearchIcon } from '@/icons';
import { useQueryFilters } from "../../../../../../hooks/useQueryFilters";
import type { SummaryFilters } from "../../../Attendance/_types";

export default function LeaveSummeryFilter() {
  const [searchValue, setSearchValue] = useState("");
  const { filters, setFilterValue } = useQueryFilters<SummaryFilters>();
  const { data: departmentsData } = useGetAllDepartmentsQuery({ params: { status: 'active' } });
  // const { data: employeesData } = useGetAllEmployeesQuery({
  //   params: {
  //     page: 1,
  //     limit: 1000,
  //   },
  // });

  // Set default to current month if no month is selected
  useEffect(() => {
    if (!filters.date) {
      const currentMonth = dayjs().format("YYYY-MM");
      setFilterValue("date", currentMonth);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Space className="filter-section" wrap>
        {/* <Select
          size="large"
          showSearch
          allowClear
          placeholder="Search Employee / ID"
          className="w-64 !border !border-white !rounded-lg"
          optionFilterProp="label"
          onChange={(value) => setFilterValue("employee_id", value)}
          // prefix={<SearchIcon size={24} />}
          options={
            employeesData?.data?.data?.map((employee) => ({
              value: employee.employee_id,
              label: `${employee.name} (${employee.employee_id})`,
            })) || []
          }
        /> */}

        <Input
          size="large"
          value={searchValue}
          onChange={(e) => {
            const value = e.target.value;
            setSearchValue(value);
            setFilterValue("search", value);
          }}
          className="shrink-0 w-72"
          placeholder="Search Employee ID/Name"
          prefix={<SearchIcon size={24} />}
          allowClear
        />

        <DatePicker
          picker="month"
          size="large"
          placeholder="Select Month"
          className="w-40"
          suffixIcon={<Calendar03Icon size={16} />}
          format="YYYY MMMM"
          value={filters.date ? dayjs(filters.date, "YYYY-MM") : undefined}
          onChange={(value) =>
            setFilterValue("date", value ? value.format("YYYY-MM") : undefined)
          }
          showToday={false}
        />

        <Select
          size="large"
          allowClear
          style={{ width: 130 }}
          placement="bottomRight"
          placeholder="Department"
          styles={{ popup: { root: { width: 200 } } }}
          suffixIcon={<ChevronDownIcon className="text-white" size={24} />}
          onChange={(value) => setFilterValue("department", value)}
          options={
            departmentsData?.data?.data?.map((department) => ({
              value: department.id,
              label: department.name,
            })) || []
          }
        />
      </Space>
    </>
  );
}
